export type LeaveSaveOutcome = "success" | "failure" | "unchanged" | null;

/** Result returned by save-before-leave handlers to the unsaved-changes guard. */
export type SaveBeforeLeaveResult = "success" | "validation_failed" | "save_failed";

export function isLeaveSaveSuccessful(outcome: LeaveSaveOutcome): boolean {
    return outcome === "success" || outcome === "unchanged";
}

export function toSaveBeforeLeaveResult(leaveOutcome: LeaveSaveOutcome): SaveBeforeLeaveResult {
    return isLeaveSaveSuccessful(leaveOutcome) ? "success" : "save_failed";
}

/** Accept legacy boolean onSave handlers alongside SaveBeforeLeaveResult. */
export function normalizeSaveBeforeLeaveResult(
    result: boolean | SaveBeforeLeaveResult
): SaveBeforeLeaveResult {
    if (result === true) return "success";
    if (result === false) return "save_failed";
    return result;
}
